export const PLATFORM_MAPPER = {
    messenger: 'facebook_page',
    whatsapp: 'whatsapp',
    instagram: 'instagram'
};
